
export default {
  name: 'EoTransitionAccordion',
  functional: true,
  props: {
    /**
     * Duration of the transition in milliseconds
     */
    duration: {
      type: [String, Number],
      default: 800,
    },
    /**
     * Direction of the expansion: (x) (y)
     */
    direction: {
      type: String,
      validator: prop => Object.values(['x', 'y']).includes(prop),
      default: 'y',
    },
    /**
     * Scroll accordion contents after opening accordion
     */
    scrollIntoView: {
      type: Boolean,
      default: false,
    },
  },
  render (createElement, context) {
    const transitionName = 'accordion'
    let cachedHeight = null

    const setDuration = (el) => {
      el.style.transitionDuration = Number(context.props.duration) + 'ms'
    }

    const scrollTo = (el) => {
      if (context.props.scrollIntoView) {
        el.scrollIntoView({behavior: "smooth", block: "center"})
      }
    }

    const setCollapsedSize = (el) => {
      switch (context.props.direction) {
        case 'y':
          el.style.height = '0px'
          break
        case 'x':
          el.style.height = getNaturalHeight(el) + 'px'
          el.style.width = '0px'
          break
      }
      el.classList.add(transitionName + '-collapsed-' + context.props.direction)
    }

    const setNaturalSize = (el) => {
      switch (context.props.direction) {
        case 'y':
          el.style.height = el.scrollHeight + 'px'
          break
        case 'x':
          el.style.height = getNaturalHeight(el) + 'px'
          el.style.width = el.scrollWidth + 'px'
          break
      }
      el.classList.remove(transitionName + '-collapsed-' + context.props.direction)
    }

    const getNaturalHeight = (el) => {
      // Keep track of natural height when width is collapsed
      if (!cachedHeight) {
        const cachedDisplay = el.style.display
        const cachedVisibility = el.style.visibility

        el.style.display = ''
        el.style.visibility = 'hidden'
        cachedHeight = el.offsetHeight
        fixChildrenWidths(el)

        el.style.display = cachedDisplay
        el.style.visibility = cachedVisibility
      }
      return cachedHeight
    }

    const fixChildrenWidths = (el) => {
      const children = [...el.childNodes]
      children.forEach((child) => {
        if (window) {
          const dimensions = child.getBoundingClientRect()
          const currentWidth = dimensions.width
          child.style.width = currentWidth + 'px'

          const currentDisplay = window.getComputedStyle(child, null).getPropertyValue('display')
          child.style.display = currentDisplay == 'inline' ? 'inline-block' : currentDisplay
        }
      })
    }
    
    const unsetStyles = (el) => {
      cachedHeight = null
      el.classList.remove(transitionName + '-collapsed-' + context.props.direction)
      el.style.transitionDuration = ''
      el.style.height = ''
      el.style.width = ''

      if (context.props.direction === 'x') {
        const children = [...el.childNodes]
        children.forEach((child) => {
          if (child.style) {
            child.style.width = ''
            child.style.display = ''
          }
        })
      }
    }

    // Render the <transition> element
    return createElement(
      'transition',
      {
        ...context.data,
        props: {
          name: transitionName,
          duration: Number(context.props.duration),
        },
        on: {
          beforeEnter (el) {
            setDuration(el)
            setCollapsedSize(el)
          },
          enter (el) {
            setTimeout(() => {
              setNaturalSize(el)
            })
          },
          afterEnter (el) {
            unsetStyles(el)
            scrollTo(el)
          },
          beforeLeave (el) {
            setDuration(el)
            setNaturalSize(el)
          },
          leave (el) {
            setTimeout(() => {
              setCollapsedSize(el)
            })
          },
          afterLeave (el) {
            unsetStyles(el)
          },
        },
      },
      context.children,
    )
  },
}
